import React, {useState} from "react";
import moment from "moment";

const RequestPassDateRenderer = (props) => {
  const [dates, setDates] = useState(props.value || []);

  const compare = (a, b) => {
    if (moment(b.update_date).format('DD/MM/YYYY à HH:mm') < moment(a.update_date).format('DD/MM/YYYY à HH:mm')) {
      return 1;
    }
    if (moment(b.update_date).format('DD/MM/YYYY à HH:mm') > moment(a.update_date).format('DD/MM/YYYY à HH:mm')) {
      return -1;
    }
  }
  const associateHeaderName = () => {
    switch (props.colDef.headerName) {
      case 'date réception' : {
        return [1];
      }
      case 'date réception dossier' : {
        return [1];
      }
      case 'date prise en charge' : {
        return [2, 3, 4, 5]
      }
      case 'date prise en charge dossier' : {
        return [2, 3, 4, 5]
      }
      case 'date envoi' : {
        return [6];
      }
      case 'date retour' : {
        return [7];
      }
      case 'date fact.' : {
        return [9];
      }
      case 'date réponse' : {
        return [8, 10, 11];
      }
      case 'instructeur' : {
        return [1,2,3,4,5,6,7,8,9,10,11];
      }
      default: {
        return [0];
      }
    }
  }
  const organizeArray = () => {
    let copie_dates = dates.slice();
    let valeur = null;
    let instructeur = null;
    copie_dates.sort(compare);
    let tab = associateHeaderName();
    for (let date = 0; date < copie_dates.length; date++) {
      for (let value = 0; value < tab.length; value++) {
        if (copie_dates[date].id_status === tab[value]) {
          valeur = moment(copie_dates[date].update_date).format('DD/MM/YYYY à HH:mm');
          instructeur = copie_dates[date].instructeur_account.login;
        }
      }
    }
    if (valeur === null) {
      valeur = "-";
    }
    if (instructeur === null) {
      instructeur = "-";
    }
    return (props.colDef.headerName === 'instructeur' ? instructeur : valeur);
  }

  return (organizeArray() || null)

}

export default RequestPassDateRenderer;
